import Icon from '../components/Icon';
import Input from '../components/Input';
import Switch from '../components/Switch';
import type { TextElement } from '../types/news';
import RichTextEditor from './RichTextEditor';

type Props = {
  element: TextElement;
  onUpdate: (id: string, updates: Partial<TextElement>) => void;
  onDelete: (id: string) => void;
  onMoveUp?: () => void;
  onMoveDown?: () => void;
  isFirst?: boolean;
  isLast?: boolean;
};

export default function TextSection({
  element,
  onUpdate,
  onDelete,
  onMoveDown,
  onMoveUp,
  isFirst,
  isLast,
}: Props) {
  return (
    <div className="border border-gray-tint-6 rounded-_20 padding-3 w-full margin-top-2">
      <div className="flex justify-between items-center margin-bottom-2">
        <h3>Textabschnitt</h3>
        <div className="flex gap-1 items-center">
          <Icon
            name="icon-arrow-up"
            size={1}
            className={
              isFirst ? 'opacity-30 cursor-not-allowed' : 'cursor-pointer'
            }
            onClick={!isFirst ? onMoveUp : undefined}
          />
          <Icon
            name="icon-arrow-down"
            size={1}
            className={
              isLast ? 'opacity-30 cursor-not-allowed' : 'cursor-pointer'
            }
            onClick={!isLast ? onMoveDown : undefined}
          />
          <Icon
            name="icon-bin"
            onClick={() => onDelete(element.id)}
            size={1}
            className="cursor-pointer"
          />
        </div>
      </div>

      <div className="flex justify-between items-center margin-bottom-2">
        <span>Untertitel einfügen</span>
        <Switch
          checked={element.hasSubtitle}
          onChange={() =>
            onUpdate(element.id, { hasSubtitle: !element.hasSubtitle })
          }
        />
      </div>

      {element.hasSubtitle && (
        <div className="flex flex-col gap-1 margin-bottom-2">
          <label>Untertitel eingeben</label>
          <Input
            value={element.subtitle}
            maxlength={120}
            onChange={(value) =>
              onUpdate(element.id, { subtitle: value ?? '' })
            }
            placeholder="Untertitel eingeben"
          />
        </div>
      )}

      <div className="flex flex-col gap-1">
        <label>Textabschnitt verfassen</label>
        <RichTextEditor
          value={element.text}
          onChange={(value) => onUpdate(element.id, { text: value })}
          placeholder="Schreibe deinen Textabschnitt..."
        />
      </div>
    </div>
  );
}
